module.exports = __webpack_public_path__ + "img/infoMineria.2f53483b.jpg";